import { axiosPrivate } from '../api/axios';
import axios from "../api/axios";
// import { useEffect } from 'react';
import useRefreshToken from './useRefreshToken';
import useAuth from './useAuth';
import { useNavigate } from 'react-router-dom';
import { EMPTY_AUTH } from "../context/AuthProvider";




const LOGOUT_URL = "/auth/logout";

const useLogout = () => {
  const navigate = useNavigate();
  const { setAuth } = useAuth();

  const logout = async () => {
    try {
      // invalidate refresh token (cookie)
      await axios.post(
        LOGOUT_URL,
        {},
        { withCredentials: true }
      );
    } catch (err) {
      // even if this fails, continue logout
      console.warn("Logout request failed");
    }

    // clear frontend auth
    setAuth(EMPTY_AUTH);
    // need to fix this 
    sessionStorage.clear();

    navigate("/", { replace: true });
  };

  return logout;
};

export default useLogout;
